import { Form, Select } from '@bynder/design-system';
import { useActiveWidget } from '../../../../../queries/guides';
import { CollectionWidget } from '../../../../../types/widgets/collections';
import { Props } from './types';
import { Translate } from '@bynder/localization';

const AssetsShownSelector: React.FC<Props> = ({ handleChange }) => {
  const widget = useActiveWidget() as CollectionWidget;
  const { assetsShown } = widget.collectionSettings;

  return (
    <Form.Group>
      <Form.Label id="assetCount">
        <Translate id="WIDGETS_INSPECTOR.COLLECTION_ASSET_COUNT_TITLE" />
      </Form.Label>
      <Select
        value={assetsShown?.toString()}
        onChange={value => handleChange('assetsShown', Number(value))}
        label={
          <Translate
            id="WIDGETS_INSPECTOR.COLLECTION_ASSET_COUNT"
            count={assetsShown}
          />
        }
        aria-labelledby="assetCount"
      >
        <Select.Item value="4">
          <Translate id="WIDGETS_INSPECTOR.COLLECTION_ASSET_COUNT" count={4} />
        </Select.Item>
        <Select.Item value="8">
          <Translate id="WIDGETS_INSPECTOR.COLLECTION_ASSET_COUNT" count={8} />
        </Select.Item>
        <Select.Item value="16">
          <Translate id="WIDGETS_INSPECTOR.COLLECTION_ASSET_COUNT" count={16} />
        </Select.Item>
        <Select.Item value="32">
          <Translate id="WIDGETS_INSPECTOR.COLLECTION_ASSET_COUNT" count={32} />
        </Select.Item>
        <Select.Item value="64">
          <Translate id="WIDGETS_INSPECTOR.COLLECTION_ASSET_COUNT" count={64} />
        </Select.Item>
      </Select>
    </Form.Group>
  );
};

export default AssetsShownSelector;
